export const isActiveSiteLayoutToolkitUser = licences => {

  for (let i = 0; i < licences.length; i++) {
    if (licences[i].domain.match(/housing/) && licences[i].domainstatus === "Active")
      return true;
  }
  return false;
}